import { layout } from 'thewest/App.routing'

export const politicsSegment = layout.component({
    type: 'uniform',
    props: {
        section: 'politics',
        verticalSpacing: 'xl',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            ['teaserWithBackground'],
            ['commonWithBackground', 'titleOnly'],
            ['teaserWithBackground'],
            {
                type: 'november',
                listLength: 5,
                hasTimestamp: true,
            },
        ],
        sectionHeader: {
            heading: 'Politics',
            headingUrl: '/politics',
            section: 'politics',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'politics',
            offset: 0,
            pageSize: 9,
        },
    },
})
